import { Fragment } from 'react';
import { Stack } from '@mui/material';

import CheckboxGroup from './components/CheckboxTwo';
import { IFormValues } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContentSub';
import SectionTitle from '../../components/SectionTitle';
import MuiRadioGroup from './components/MuiRadioGroup';

interface Props extends IFormValues {
  disabled?: boolean;
}

const MoodAffect = (props: Props) => {
  const { disabled, getValues, setValue } = props;

  return (
    <Fragment>
      <SectionTitle title="기분" />

      <RowContainer xs={12}>
        <RowContent title="기분(mood)" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={3}>
            <MuiRadioGroup
              i18nKey="MOOD.RADIO"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('mood_affect.mood.value')}
              onChange={v => {
                setValue('mood_affect.mood.value', v);
              }}
            />
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={0} childrenRatio={12}>
          <Stack
            direction="column"
            spacing={1}
            sx={{
              border: '1px solid #c0bebed4',
              borderRadius: '7px',
              marginTop: '-50px',
              padding: '8px',
            }}
          >
            <CheckboxGroup
              i18nNullKey="ETC"
              i18nKey="MOOD.CHECKBOX"
              values={[1, 2, 3, 4, 5, 6]}
              disabled={disabled}
              defaultValue={getValues('mood_affect.mood.checked')}
              onChange={v => setValue('mood_affect.mood.checked', v)}
            />
            <CheckboxGroup
              i18nNullKey="ETC"
              i18nKey="MOOD.CHECKBOX"
              values={[7, 8, 9, 10, 11]}
              disabled={disabled}
              defaultValue={getValues('mood_affect.mood_two.checked')}
              onChange={v => setValue('mood_affect.mood_two.checked', v)}
            />
          </Stack>
        </RowContent>
        <RowContent title="정서 (affect)" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={3}>
            <MuiRadioGroup
              i18nKey="MOOD.RADIO"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('mood_affect.affect.value')}
              onChange={v => {
                setValue('mood_affect.affect.value', v);
              }}
            />
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={0} childrenRatio={12}>
          <Stack
            direction="column"
            spacing={1}
            sx={{
              border: '1px solid #c0bebed4',
              borderRadius: '7px',
              marginTop: '-50px',
              padding: '8px',
            }}
          >
            <CheckboxGroup
              i18nNullKey="ETC"
              i18nKey="AFFECT.CHECKBOX"
              values={[1, 2, 3, 4, 5, 6]}
              disabled={disabled}
              defaultValue={getValues('mood_affect.affect.checked')}
              onChange={v => setValue('mood_affect.affect.checked', v)}
            />
          </Stack>
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default MoodAffect;
